import DataTable_s from "components/table/data-table-styles"
import styled from "styled-components"

export const Attributes_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const AttributeTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin-top: -5px;
  
  .p-datatable-frozen-view .p-datatable-scrollable-header-table {
    position: fixed;
    z-index: 90;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }
`